/* eslint-disable react/jsx-no-duplicate-props */
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Container } from "react-bootstrap";
import SaleOrdersFormCustomerInfoView from "./Includes/SaleOrdersFormCustomerInfoView";
import SaleOrdersFormProductsView from "./Includes/SaleOrdersFormProductsView";
import SaleOrdersFormShippingView from "./Includes/SaleOrdersFormShippingView";
import SaleOrdersFormFinalizeView from "./Includes/SaleOrdersFormFinalizeView";
import { ERROR_WHILE__NAME } from "utlis/AppMessages/AppMessages";
import { addCustomerAddress, editCustomerAddress, getCustomerAddresses, getCustomerCountries, getCustomerGroups, getCustomers } from "utlis/Apis/Customers_API";
import FeatherIcon from 'feather-icons-react';
import { setGlobalLoading } from "redux/actions/actionCommon";
import uuid from "react-uuid";
import { getFromLocalStorage, saveToLocalStorage } from "utlis/helpers/Common/CommonHelperFunctions";
import { getCartByTemp } from "utlis/Apis/Cart_API";

function SaleOrder(props) {
  // props
  const { authState } = props

  const submitButtonRef = useRef(null)
  const [goSteps, setGoSteps] = useState(0);
  const [customerGroups, setCustomerGroups] = useState([])
  const [countries, setCountries] = useState([])
  const [customers, setCustomers] = useState([])
  const [addresses, setAddresses] = useState([]);
  const [customer, setCustomer_] = useState({ isNew: false });
  const [bAddress, setBAddress_] = useState({})
  const [sAddress, setSAddress_] = useState({})
  const [currency, setCurrency] = useState("$")
  const [order, setOdrer_] = useState({
    shippingCost: 0,
    shippingType: "",
    payment_processor: "CASH"
  })
  const [lines, setLines] = useState([{}])
  const [token_id, setToken] = useState("")

  document.querySelectorAll(".step-label").forEach((item) => {
    item.setAttribute("style", "font-family: Source Sans Pro, sans-serif");
  });

  useEffect(() => {
    const customerId = props.match.params.id ?? ""
    let tempId = getFromLocalStorage("temp_id")
    console.log(">>", tempId)
    if (customerId) {
      // const c = JSON.parse(getFromLocalStorage("temp_customer")) || {}
      // if ("" + c.user_id === "" + customerId) {
      //   setToken(tempId)
      //   const c = JSON.parse(getFromLocalStorage("temp_customer")) || {}
      //   setCustomer(c)
      //   const b = JSON.parse(getFromLocalStorage("temp_ba")) || {}
      //   setBAddress(b)
      //   const s = JSON.parse(getFromLocalStorage("temp_sa")) || {}
      //   setSAddress(s)
      //   setOrder(JSON.parse(getFromLocalStorage("temp_order")) || {})
      //   getCustomerAddresses_(c.user_id, b, s)
      // } else {
      //   tempId = uuid()
      //   setToken(tempId)
      //   saveToLocalStorage("temp_id", tempId)
      //   setCustomer({ user_id: customerId })
      //   getCustomerAddresses_(customerId, {}, {})
      // }
      reset()
      setCustomer({ user_id: customerId })
      getCustomerAddresses_(customerId, {}, {})

    } else if (!tempId) {
      reset()
    } else {
      setToken(tempId)
      const c = JSON.parse(getFromLocalStorage("temp_customer")) || {}
      setCustomer(c)
      const b = JSON.parse(getFromLocalStorage("temp_ba")) || {}
      setBAddress(b)
      const s = JSON.parse(getFromLocalStorage("temp_sa")) || {}
      setSAddress(s)
      setOrder(JSON.parse(getFromLocalStorage("temp_order")) || {})
      getCustomerAddresses_(c.user_id, b, s)
    }
    getCart_(tempId)
    getCustomer_(customerId)
    getCustomerGroups_()
    getCountries_()
  }, [])


  const reset = () => {
    setCustomer({})
    setBAddress({})
    setSAddress({})
    setOrder({
      shippingCost: 0,
      shippingType: "",
      payment_processor: "CASH"
    })
    const tempId = uuid()
    setToken(tempId)
    saveToLocalStorage("temp_id", tempId)
    setLines([{}])
  }
  const getCustomerAddresses_ = (user_id, b = {}, s = {}) => {
    if (!user_id) {
      return
    }
    const headers = {
      "Authorization": `Bearer ${authState.commonToken}`,
      "Api-Token": authState.apiToken,
      "Access-Token": "",
      // "Store-Id": authState.storeId,
    }
    getCustomerAddresses(headers, user_id).then(res => {
      const addressData = res.data
      if (addressData.success) {
        setAddresses(arr => addressData.data)
        if (!b.address_id) {
          setBAddress(addressData.data.filter(e => e.is_default && e.address_type === "Billing")[0] || addressData.data.filter(e => e.address_type === "Billing")[0] || {})
        }
        if (!s.address_id) {
          setSAddress(addressData.data.filter(e => e.is_default && e.address_type === "Shipping")[0] || addressData.data.filter(e => e.address_type === "Shipping")[0] || {})
        }
      }
      if (addressData.error) {
        console.log('Error occured while loading admin groups!', res)
      }
    }).catch(err => {
      console.log(`${ERROR_WHILE__NAME} getAddresses `, err.message)
    })
  }

  const setCustomer = (c) => {
    saveToLocalStorage("temp_customer", JSON.stringify(c))
    setCustomer_(c)
  }
  const setSAddress = (data) => {
    data.address_type = "Shipping"
    saveToLocalStorage("temp_sa", JSON.stringify(data))
    setSAddress_(data)
  }
  const setBAddress = (data) => {
    data.address_type = "Billing"
    saveToLocalStorage("temp_ba", JSON.stringify(data))
    setBAddress_(data)
  }
  const setOrder = (data) => {
    saveToLocalStorage("temp_order", JSON.stringify(data))
    setOdrer_(data)
  }
  const getCustomer_ = (id) => {
    const headers = {
      "Authorization": `Bearer ${authState.commonToken}`,
      "Api-Token": authState.apiToken,
      "Access-Token": "",
      // "Store-Id": authState.storeId,
    }
    getCustomers(headers, "limit=-1").then(res => {
      const resData = res.data
      if (resData && resData.success) {
        setCustomers(resData.data)
        if (id) {
          const c = resData.data.find(e => e.user_id === parseInt(id)) || customer || {}
          setCustomer(c)
        }
      }
      if (resData && resData.error) {
      }
    }).catch(err => {
      console.log(`${ERROR_WHILE__NAME} getCustomers `, err.message)
    })
  }
  const getCart_ = (id) => {
    const headers = {
      "Authorization": `Bearer ${authState.commonToken}`,
      "Api-Token": authState.apiToken,
      "Access-Token": "",
      // "Store-Id": authState.storeId,
    }
    getCartByTemp(headers, id).then(res => {
      const resData = res.data
      if (resData && resData.success) {
        const list = []
        resData.data.content.forEach(e => {
          list.push(e)
        })
        if (list.length === 0) {
          list.push({})
        }
        setLines(arr => list)
        const { cart_discount = "", cart_sub_total = "", cart_total = "" } = resData.data
        const c = cart_discount[0] || "$"
        setCurrency(c)
        order.cart_discount = cart_discount
        order.cart_sub_total = cart_sub_total
        order.cart_total = cart_total
        setOrder(order)
      }
      if (resData && resData.error) {
      }
    }).catch(err => {
      console.log(`${ERROR_WHILE__NAME} getCustomers `, err.message)
    })
  }

  const getCustomerGroups_ = () => {
    const headers = {
      "Authorization": `Bearer ${authState.commonToken}`,
      "Api-Token": authState.apiToken,
      "Access-Token": "",
      // "Store-Id": authState.storeId,
    }
    getCustomerGroups(headers).then(res => {
      const customerGroupData = res.data
      if (customerGroupData.success) {
        setCustomerGroups(customerGroupData.data)
      }
      if (customerGroupData.error) {
        console.log('Error occured while loading customer groups!', res)
      }
    }).catch(err => {
      console.log(`${ERROR_WHILE__NAME} getCustomerGroup `, err.message)
    })
  }

  const getCountries_ = () => {
    const headers = {
      "Authorization": `Bearer ${authState.commonToken}`,
      "Api-Token": authState.apiToken,
      "Access-Token": "",
      // "Store-Id": authState.storeId,
    }
    getCustomerCountries(headers).then(res => {
      const countriesData = res.data
      if (countriesData.success) {
        setCountries(countriesData.data)
      }
      if (countriesData.error) {
        console.log('Error occured while loading countries groups!', res)
      }
    }).catch(err => {
      console.log(`${ERROR_WHILE__NAME} getCountries `, err.message)
    })
  }

  const saveAddresses = (addressB, addressS) => {
    if (addresses.length === 0) {
      addresses.push(addressB)
      if (addressS) {
        addresses.push(addressS)
      } else {

      }
    }
    saveAddress(addressB, true)
    if (addressS) {
      saveAddress(addressS, false)
    }
  }
  const saveAddress = (address, isBilling) => {
    if (address.saveToCustomerAddressBook || !address.address_id) {
      address.user_id = customer.user_id

      if (!address.shipping_fax) {
        // address.shipping_fax = address.shipping_phone
      }
      if (!address.shipping_mobile) {
        // address.shipping_mobile = address.shipping_phone
      }
      if (isBilling) {
        address.is_default = (addresses.filter(e => e.is_default && e.address_type === "Billing").length > 0) ? 0 : 1
      } else {
        address.is_default = (addresses.filter(e => e.is_default && e.address_type === "Shipping").length > 0) ? 0 : 1
      }
      if (!address.address_id) {
        const headers = {
          "Authorization": `Bearer ${authState.commonToken}`,
          "Api-Token": authState.apiToken,
          "Access-Token": "",
          // "Store-Id": authState.storeId,
        }
        addCustomerAddress(headers, address).then(res => {
          address.address_id = res.data.data || res.data.address_id
          if (isBilling) {
            console.log(">>>", "7")
            setBAddress(address)
          } else {
            setSAddress(address)
          }
        }).catch(err => { })
      } else {
        const headers = {
          "Authorization": `Bearer ${authState.commonToken}`,
          "Api-Token": authState.apiToken,
          "Access-Token": "",
          // "Store-Id": authState.storeId,
        }
        editCustomerAddress(headers, address).then(res => { }).catch(err => { })
      }
    }
  }

  const handleFormSubmission = (ev) => {
    ev.preventDefault()
    submitButtonRef.current.click()
  }

  return (
    <section
      id="app-saleOrders__create-details"
      className="st-def-mar-TB"
    >
      <Container fluid className="st-container">
        <div className="app-saleOrders__create-details">
          <div className="app-header-wrapper mb-4">
            <p className="app-heading text-capitalize">Create Sale Order</p>
            <p className="app-desc">Create a sale order.</p>
          </div>
          <div
            className="sale-content-container">
            <div className="sale-order-steps">
              <div className="sale-order-stepper">
                <div className="stepper-container">
                  <div className="stepper-step">
                    <button className={`${goSteps === 0 ? "active" : "completed"}`}
                      onClick={(e => {
                        if (goSteps > 0) {
                          setGoSteps(0)
                        }
                      })}

                    >
                      <span className="stepper-label">
                        {goSteps === 0 ? "1" :
                          <FeatherIcon
                            icon="check"
                            size="18"
                            className="icon position-relative"
                            style={{ strokeWidth: 4 }}
                          />}
                      </span>
                    </button>
                    <div className={`stepper-title ${goSteps === 0 ? "active" : "completed"}`}>
                      <span className="step-label" style={{ fontFamily: 'Source Sans Pro, sans-serif' }}>
                        Customer Info
                      </span>
                    </div>
                  </div>
                </div>

                <div className="stepper-container">
                  <div className="vertical-border active">
                    <span className={`center-border ${goSteps === 0 ? "active" : "completed"}`}></span>
                  </div>
                  <div className="stepper-step">
                    <button className={`${goSteps > 1 ? "completed" : goSteps !== 0 ? "active" : goSteps === 0 ? "" : ""}`}
                      onClick={(e => {
                        if (goSteps > 1) {
                          setGoSteps(1)
                        }
                      })}
                    >
                      <span className="stepper-label">
                        {
                          goSteps > 1 ? <FeatherIcon
                            icon="check"
                            size="18"
                            className="icon position-relative"
                            style={{ strokeWidth: 4 }}
                          /> :
                            goSteps !== 0 ? "2" :
                              goSteps === 0 ? "2" : ""
                        }

                      </span>
                    </button>
                    <div className={`stepper-title ${goSteps > 1 ? "completed" : goSteps !== 0 ? "active" : goSteps === 0 ? "" : ""}`}>
                      <span className="step-label " style={{ fontFamily: 'Source Sans Pro, sans-serif' }}>Products</span>
                    </div>
                  </div>
                </div>

                <div className="stepper-container">
                  <div className="vertical-border">
                    <span className={`center-border ${goSteps > 1 ? "completed" : goSteps === 1 ? "active" : ""}`}></span></div>
                  <div className="stepper-step">
                    <button className={`${goSteps > 2 ? "completed" : goSteps !== 0 && goSteps !== 1 ? "active" : goSteps === 0 && goSteps === 1 ? "" : ""}`}
                      onClick={(e => {
                        if (goSteps > 2) {
                          setGoSteps(2)
                        }
                      })}
                    >
                      <span className="">
                        {
                          goSteps > 2 ? <FeatherIcon
                            icon="check"
                            size="18"
                            className="icon position-relative"
                            style={{ strokeWidth: 4 }}
                          /> :
                            goSteps !== 0 && goSteps !== 1 ? "3" : "3"
                        }
                      </span>

                    </button>
                    <div className={`stepper-title ${goSteps > 2 ? "completed" : goSteps !== 0 && goSteps !== 1 ? "active" : goSteps === 0 && goSteps === 1 ? "" : ""}`}>
                      <span className="step-label " style={{ fontFamily: 'Source Sans Pro, sans-serif' }}>Shipping</span>
                    </div>
                  </div>
                </div>

                <div className="stepper-container">
                  <div className="vertical-border">
                    <span className={`center-border ${goSteps === 3 ? "completed" : goSteps === 2 ? "active" : ""}`}></span></div>
                  <div className="stepper-step">
                    <button className={`${goSteps === 3 ? "active" : ""}`}>
                      <span className="">
                        4
                      </span>
                    </button>
                    <div className={`stepper-title ${goSteps === 3 ? "active" : ""}`}>
                      <span className="step-label" style={{ fontFamily: 'Source Sans Pro, sans-serif' }}>Finalize</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {goSteps === 0 && (
              <SaleOrdersFormCustomerInfoView
                resetAll={reset}
                setGoSteps={setGoSteps}
                customer={customer}
                bAddress={bAddress}
                sAddress={sAddress}
                setCustomer={(data) => {
                  console.log(">>>1")
                  setCustomer(data)
                }}
                setBAddress={(data) => {
                  setBAddress(data)
                }}
                setSAddress={(data) => {
                  setSAddress(data)
                }}

                customers={customers}
                countries={countries}
                customerGroups={customerGroups}
                bAddress={bAddress}
                sAddress={sAddress}
                addresses={addresses}
                setAddresses={setAddresses}
                handleFormSubmission={handleFormSubmission}
                saveAddresses={saveAddresses}
                getCustomers={() => {
                  getCustomer_()
                }}
                getCart={() => {
                  getCart_(token_id)
                }}
                currency={currency}
              />
            )}
            {goSteps === 1 && (
              <SaleOrdersFormProductsView
                setGoSteps={setGoSteps}
                token_id={token_id}
                lines={lines}
                setLines={setLines}
                customer={customer}
                bAddress={bAddress}
                sAddress={sAddress}
                getCart={() => {
                  getCart_(token_id)
                }}
                currency={currency}
              />
            )}
            {goSteps === 2 && (
              <SaleOrdersFormShippingView
                setGoSteps={setGoSteps}
                customer={customer}
                bAddress={bAddress}
                sAddress={sAddress}
                setSAddress={(data) => {
                  setSAddress(data)
                }}
                token_id={token_id}
                addresses={addresses}
                setAddresses={setAddresses}
                getAddresses={() => { getCustomerAddresses_(customer.user_id, bAddress, sAddress) }}
                order={order}
                setOrder={(data) => {
                  setOrder(data)
                }}
                currency={currency}
              />
            )}
            {goSteps === 3 && (
              <SaleOrdersFormFinalizeView
                setGoSteps={setGoSteps}
                customer={customer}
                bAddress={bAddress}
                sAddress={sAddress}
                setBAddress={(data) => {
                  setBAddress(data)
                }}
                setSAddress={(data) => {
                  setSAddress(data)
                }}
                countries={countries}
                lines={lines}
                token_id={token_id}
                setLines={setLines}
                order={order}
                setOrder={setOrder}
                saveAddresses={saveAddresses}
                history={props.history}
                currency={currency}
              />
            )}
          </div>
        </div>
      </Container >
    </section >
  );
}

const getDataFromStore = (state) => {
  return {
    authState: state.auth,
    sideBarVisibility: state.common.sideBarVisibility,
  };
};

const dispatchActionsToProps = (dispatch) => {
  return {
    setGlobalLoading: (bool) => dispatch(setGlobalLoading(bool)),
  };
};

export default connect(getDataFromStore, dispatchActionsToProps)(SaleOrder);
